import { Link } from 'react-router-dom';
import { hotRanking, comics } from '@/mocks/comics';

export default function HotRanking() {
  const getComicById = (id: number) => comics.find((c) => c.id === id);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14" aria-labelledby="ranking-title">
      <h2 id="ranking-title" className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
        热门榜单
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-background-100 rounded-lg p-4 md:p-5">
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-fire-line text-accent-500 text-xl"></i>
            <h3 className="text-base font-heading font-semibold text-foreground-900">人气排行 TOP10</h3>
          </div>
          <div className="space-y-0">
            {hotRanking.map((item) => {
              const comic = getComicById(item.comicId);
              if (!comic) return null;
              return (
                <Link
                  key={item.rank}
                  to={`/comic/${item.comicId}`}
                  className="flex items-center gap-3 py-2.5 border-b border-background-200/70 last:border-0 hover:bg-background-50 transition-colors duration-150 rounded px-2 -mx-2 cursor-pointer"
                >
                  <span
                    className={`w-6 h-6 flex items-center justify-center rounded text-xs font-bold flex-shrink-0 ${
                      item.rank <= 3
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <span className="text-sm font-medium text-foreground-800 line-clamp-1">{item.title}</span>
                  </div>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.views}</span>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="bg-background-100 rounded-lg p-4 md:p-5">
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-star-line text-primary-500 text-xl"></i>
            <h3 className="text-base font-heading font-semibold text-foreground-900">高分神作</h3>
          </div>
          <div className="space-y-0">
            {comics
              .sort((a, b) => b.rating - a.rating)
              .slice(0, 10)
              .map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="flex items-center gap-3 py-2.5 border-b border-background-200/70 last:border-0 hover:bg-background-50 transition-colors duration-150 rounded px-2 -mx-2 cursor-pointer"
                >
                  <span
                    className={`w-6 h-6 flex items-center justify-center rounded text-xs font-bold flex-shrink-0 ${
                      index < 3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <span className="text-sm font-medium text-foreground-800 line-clamp-1">{comic.title}</span>
                  </div>
                  <span className="text-xs font-semibold text-primary-500 whitespace-nowrap">{comic.rating}</span>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}